// extracted by mini-css-extract-plugin
module.exports = {"hoursTable":"az_ekc","todayRow":"az_fkc","timeCell":"az_gkc","holidayLabel":"az_hkc","holidayTime":"az_ikc","closedText":"az_jkc"};